import { type ReactElement } from "react"
import { observer } from "mobx-react-lite"

import appStore from "@/stores/appStore"

import { CatalogMenuDesktop } from "./CatalogMenuDesktop"
import { CatalogMenuMobile } from "./CatalogMenuMobile"

type CatalogMenuProps = {
  presentation?: "desktop" | "mobile"
  trigger?: ReactElement
}

const CatalogMenu = ({ presentation = "desktop", trigger }: CatalogMenuProps) => {
  const Component = presentation === "mobile" ? CatalogMenuMobile : CatalogMenuDesktop

  return <Component categories={appStore.categories} trigger={trigger} />
}

const ObservedCatalogMenu = observer(CatalogMenu)

export default ObservedCatalogMenu
